import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { Grid, Tab, Menu } from 'semantic-ui-react';

import { APP_NAME, ADMIN_TABS } from '../../../utils/constant';
import { CustomSegment } from '../../../components';
import { find } from '../../../utils/lodash';
import { getPolicies, getEventTypes } from '../../../store/actions';

import { OutcomesParent, ParentEventDetails, OutputFormatter } from './forms';
import EvaluationMethods from './forms/EvaluationMethods';
import EvaluationQuestionsParent from './forms/EvaluationQuestionsParent';

import '../admin.scss';

const ActivitySettingAdmin = (props) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const auth = useSelector(state => state.authentication);
  // const user = useSelector(state => state.authentication.user);
  const eventTypes = useSelector((state) => state.extra.eventTypes);
  const policies = useSelector((state) => state.extra.policies);
  // const helpTips = useSelector(state => state.extra.activityHelpTips);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const { match } = props;
    const tab = find(ADMIN_TABS(t), (o) => o.route === match?.params?.type);

    if (!match?.params?.type || !tab) {
      // empty "type" - navigate to first tab's route so the URL is correct
      // (currentTab is already 0, as required)
      navigate(getFullRoute(ADMIN_TABS(t)[0].route));
    } else {
      // set initial tab based on url param "type" if not tab 0 (the default tab)
      if (tab?.id > 0) {
        setCurrentTab(tab.id);
      }
    }
  });

  useEffect(() => {
    dispatch(getEventTypes());
    dispatch(getPolicies());
  }, [dispatch]);

  const getFullRoute = (tabRoute) => `/admin/activity-settings/${tabRoute}`;

  const generateTabs = () => {
    document.title = `${t('admin.activity_settings.title')} | ${APP_NAME}`;

    const panes = [
      {
        menuItem: t('common.outcomes'),
        render: () => (
          <Menu.Item className="admin-menu-item no-print">
            <CustomSegment
              title={t('common.outcomes')}
              children={<OutcomesParent policies={policies} />}
              className="org-activity-segment"
            />
          </Menu.Item>
        ),
      },
      {
        menuItem: t('admin.activity_settings.evaluation_methods_tab'),
        render: () => (
          <Menu.Item className="admin-menu-item no-print">
            <CustomSegment
              title={t('admin.activity_settings.evaluation_methods_tab')}
              children={<EvaluationMethods />}
              className="org-activity-segment"
            />
          </Menu.Item>
        ),
      },
      {
        menuItem: t('admin.activity_settings.evaluation_questions_tab'),
        render: () => (
          <Menu.Item className="admin-menu-item no-print">
            <CustomSegment
              title={t('admin.activity_settings.evaluation_questions_tab')}
              children={<EvaluationQuestionsParent />}
              className="org-activity-segment"
            />
          </Menu.Item>
        ),
      },
      {
        menuItem: t('admin.activity_settings.output_formatters_tab'),
        render: () => (
          <Menu.Item className="admin-menu-item no-print">
            <CustomSegment
              title={t('admin.activity_settings.output_formatters_tab')}
              children={<OutputFormatter />}
            />
          </Menu.Item>
        ),
      },
      {
        menuItem: t('common.activity_types'),
        render: () => (
          <Menu.Item className="admin-menu-item no-print">
            <CustomSegment
              title={t('common.activity_types')}
              children={<ParentEventDetails eventTypes={eventTypes} />}
              className="org-activity-segment"
            />
          </Menu.Item>
        ),
      },
    ];

    return panes;
  };

  const onTabClick = (data) => {
    changeRoute(data.activeIndex);
  };

  /*****
  const onClickUsersExport = async () => {
    await props.exportSystemUsers();
    const { usersCsvLink } = props;
    if (!isEmpty(usersCsvLink)) {
      window.open(usersCsvLink.download_link, '_blank');
    }
  };
  *****/

  const changeRoute = async (value) => {
    try {
      const tab = await find(ADMIN_TABS(t), (o) => {
        return o.id === value || o.route === value;
      });
      if (!tab) {
        return false;
      }
      navigate(getFullRoute(tab.route));
      setCurrentTab(tab.id);
    } catch (error) {
      console.error('ActivitySettingAdmin ~ changeRoute ~ error', error);
      return false;
    }
  };

  return (
    <Grid.Row>
      <Tab
        menu={{ borderless: true, attached: false, tabular: false }}
        panes={generateTabs()}
        className={isMobile ? 'custom-tabs-mobile' : 'custom-tabs-admin'}
        activeIndex={currentTab}
        onTabChange={(e, data) => onTabClick(data)}
      />
    </Grid.Row>
  );
};

export default ActivitySettingAdmin;
